import React, { useState, useMemo, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import Input from './Input'
import { createQueryString } from '../../utils/queryParams'
import { debounce } from '../../utils/helpers'

const SearchFilter = ({
  getItems,
  setSearchText,
  searchText,
  query,
  placeholder,
  debounceMs = 300,
  name = 'filter',
  id = 'search-filter',
}) => {
  const [filter, setFilter] = useState(searchText)
  const queryRef = useRef(query)
  const mountedRef = useRef(true)
  queryRef.current = query

  const debouncedGetItems = useMemo(
    () =>
      debounce(value => {
        getItems(
          createQueryString({ ...queryRef.current, filter: value })
        )
      }, debounceMs),
    [getItems, debounceMs]
  )

  useEffect(() => {
    mountedRef.current = true

    return () => {
      mountedRef.current = false
      debouncedGetItems.cancel()
    }
  }, [debouncedGetItems])

  const handleSearch = ev => {
    const value = ev.currentTarget.value
    setFilter(value)

    if (mountedRef.current) {
      setSearchText(value)
    }

    debouncedGetItems(value)
  }

  return (
    <div className="SearchFilter">
      <Input
        input={{
          name,
          id,
          placeholder,
          value: filter,
          onChange: handleSearch,
        }}
      />
    </div>
  )
}

SearchFilter.propTypes = {
  searchText: PropTypes.string,
  getItems: PropTypes.func.isRequired,
  setSearchText: PropTypes.func.isRequired,
  query: PropTypes.object.isRequired,
  placeholder: PropTypes.string,
  debounceMs: PropTypes.number,
  name: PropTypes.string,
  id: PropTypes.string,
}

SearchFilter.defaultProps = {
  placeholder: 'Search',
}

export default SearchFilter
